// extracted by mini-css-extract-plugin
export var container = "applyModal-module--container--2b6c2";